import Highcharts from 'highcharts'

const options: Highcharts.Options = {
  chart: {
    marginBottom: 60,
  },
  legend: {
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
    backgroundColor: '#FFFFFF',
    margin: 100,
    floating: true,
    x: 0,
    y: 15,
  },

  tooltip: {
    borderWidth: 0,
    borderRadius: 0,
    backgroundColor: '#00000000',
    shadow: false,
    useHTML: true,
    shared: true,
  },

  yAxis: {
    title: {
      text: null,
    },
    tickAmount: 5,
  },

  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      day: '%m/%d',
      week: '%m/%d',
    },
    minPadding: 0.05,
    maxPadding: 0.05,
    minorTickLength: 0,
    tickLength: 0,
    labels: {
      y: 25,
    },
  },

  plotOptions: {
    series: {
      label: {
        connectorAllowed: true,
      },
    },
  },

  series: [
    {
      type: 'line',
      zIndex: 2,
      animation: false,
    },
    {
      type: 'line',
      dashStyle: 'LongDash',
      zIndex: 1,
      animation: false,
    },
  ],
}

export default options
